<template>

    <div class="row no-padding">
        <div class="col-xs-12 no-padding-bottom no-margin-bottom">

            <div class="alert alert-info-in-red text-center no-margin-bottom" >
                <strong>{{translateLocal("Show the device to the client")}}</strong>
                <select v-model="jobWorkerIntervention.customer.lang" class="select-language pull-right">
                    <option v-for="option in conditionLanguage"  >
                        {{ option.value }}
                    </option>
                </select>
            </div>

            <div v-if="showConditions" class="conditions conditions-scroll">
                <p v-if="customerLanguage !== 'fr'">
                    <span v-for="(textPart, index) in conditionsInCustomerLanguage.split('%onlick_append_conditions_FR%')">
                        <span v-html="nl2br(textPart)"></span>
                        <span
                                v-if="index === 0"
                                v-on:click="$refs['conditionsInFrench'].scrollIntoView()" class="btn-conditions-anchor">
                            Condition générales en Francais
                        </span>
                    </span>
                </p>
                <p v-html="nl2br(conditionsInFrench)"
                   ref="conditionsInFrench">
                </p>
            </div>

            <label for="accept_conditions_entry" v-if="showAcceptation===true" class="btn btn-default full-width">
                <nl2br tag="span" :text="translateLocal('I have read the terms and conditions \n and I accept them.')"/>
                <input type="checkbox" id="accept_conditions_entry"  class="pull-right" @click="$emit('toggleAcceptation')" v-bind:checked="accepted">
            </label>
        </div>
    </div>
</template>

<script>
    import translations from '../translations';

    export default {
        props: {
            conditions: Array,
            toggleAcceptation:Boolean,
            showAcceptation:Boolean,
            showConditions:Boolean,
            accepted:Boolean,
            jobWorkerIntervention: Object
        },
        data() {
            return {
                conditionLanguageSelected : null,
                conditionLanguage: [
                    {value: 'fr'},
                    {value: 'nl'},
                    {value: 'en'},
                    {value: 'da'},
                    {value: 'de'},
                    {value: 'pl'},
                    {value: 'it'},
                    {value: 'sv'},
                    {value: 'es'},
                ],
            }
        },
        created(){
            this.conditionLanguageSelected = this.lang;
        },
        methods: {
            nl2br(string){
                return string.replace(/(?:\r\n|\r|\n)/g, '<br>');
            },
            translateLocal(key){
                let lang = this.customerLanguage === null ? 'en': this.customerLanguage ;
                if(translations[lang][key] !== undefined){
                    return translations[lang][key];
                }else{
                    return "___" + key;
                }
            }
        },
        computed: {
            customerLanguage() {
                return this.jobWorkerIntervention.customer.lang;
            },
            conditionsInCustomerLanguage() {
                return this.conditions.find(conditions => conditions.lang === this.customerLanguage).conditions;
            },
            conditionsInFrench() {
                return this.conditions.find(conditions => conditions.lang === 'fr').conditions;
            },
        },
    }

</script>

<style scoped>

    .select-language{
        background-color: #d93128;
        color: #f85551;
        text-transform: uppercase;
        border-radius: 0px;
        border:0px;
    }

    .btn-conditions-anchor{
        color: #0088ff !important;
        text-decoration: underline;
    }

</style>
